module.exports = require('./dist/amphtml/amphtml');
